<div *ngIf="requestIsInFlight" class="text-center">
  <i id="bondsman-search-spinner" class="fa fa-spinner fa-pulse fa-5x text-center"></i>
</div>
<alert id="bondsman-search-results-alert" type="danger" *ngFor="let error of errors">{{error}}</alert>
<div class="table-responsive" id="bondsman-search-result-table-wrapper-div" *ngIf="Bondsman">    
    
<table id="bondsman-search-results-table"
       class="table table-hover table-condensed table-nowrap">
  <thead id="bondsman-search-results-table-header">
    <tr>
      <th width="30%">
        <span class="field-code">V611 </span>Bondsman/Surety Name
        <span popover="Bondsman/Surety Name description" popoverTitle="Bondsman/Surety Name" (mouseover)="popOverHandler('onShow')" (mouseleave)="popOverHandler('onHide')"><i class="fa fa-info-circle"></i></span>
      </th>
      <th width="25%">
        <span class="field-code">V603 </span>License Number
        <span popover="License Number description." popoverTitle="License Number" (mouseover)="popOverHandler('onShow')" (mouseleave)="popOverHandler('onHide')"><i class="fa fa-info-circle"></i></span>
      </th>
      <th width="30%">
        <span class="field-code">V637 </span>License Type(s)
        <span popover="License type(s) description" popoverTitle="License Type(s)" (mouseover)="popOverHandler('onShow')" (mouseleave)="popOverHandler('onHide')"><i class="fa fa-info-circle"></i></span>
      </th>
      <th width="15%">
          Actions
         <span [popover]="popTemplateForAction" popoverTitle="Actions" (mouseover)="popOverHandler('onShow')" (mouseleave)="popOverHandler('onHide')"><i class="fa fa-info-circle"></i></span>
      </th>
    </tr>
  </thead>
  <tbody id="bondsman-search-results-table-tbody">
    <ng-container *ngFor="let bondsman of Bondsman; let i = index;">
    <tr id="{{'bondsman-search-results-row-'+ i + '-table-tr-for-bondsman-info'}}"
        (click)="onViewBondsmanSelected(bondsman.getBondsmanIdentifier())"
        (mouseover)="onMouseOverBondsman(i);" 
        (mouseleave)="onMouseOffBondsman(i);" 
        [class.highlighted-bgcolor]="(mouseOverBondsmanFlags[i] || isBondsmanLastViewed(bondsman.getBondsmanIdentifier()))"> 
      <td id="{{'bondsman-search-results-row-'+ i + '-bondsman-license-name-address'}}"
          width="30%"
          title="Click for Bondsman View">
         <div class="table-responsive scroll-hide-xy"> 
           <table class="full-width table-nowrap">
             <tr>
                <td class="text-align-left">
                  <span class="field-code">V611 </span>
                  <span title="{{bondsman.getLicenseeLastName}}"> {{bondsman.getLicenseeLastName()}}, {{bondsman.getLicenseeFirstName()}}</span>
                </td>
             </tr>
             <tr *ngIf="bondsman.getLicenseeAddressLine1()">
                <td class="text-align-left">
                  <span class="field-code">V614 </span>
                  <span title="{{bondsman.getLicenseeAddressLine1()}}">{{bondsman.getLicenseeAddressLine1()}}</span>
                </td>
             </tr>
             <tr *ngIf="bondsman.getLicenseeAddressLine2()">
               <td class="text-align-left">
                  <span class="field-code">V616 </span>
                  <span title="{{bondsman.getLicenseeAddressLine2()}}">{{bondsman.getLicenseeAddressLine2()}}</span>
               </td>
             </tr>
             <tr>
               <td class="text-align-left">
                 <span class="field-code">V618 </span><span title="{{bondsman.getLicenseeCityName()}}">{{bondsman.getLicenseeCityName()}}</span><span class="field-code">V619 </span><span title="{{bondsman. getLicenseeStateAbbreviation()}}">{{bondsman. getLicenseeStateAbbreviation()}}</span>
                 <span class="field-code">V620 </span><span title="{{bondsman.getLicenseeAddressesZipCode()}}">{{bondsman.getLicenseeAddressesZipCode()}}</span>
               </td>
             </tr>
             <tr *ngIf="bondsman.getLicenseeCounty()">
               <td class="text-align-left">
                  <span class="field-code">V615 </span><span title="{{bondsman.getLicenseeCounty()}}">{{bondsman.getLicenseeCountyFormatted()}}</span>
               </td>
             </tr>
           </table>
         </div>                
      </td>
      <td id="{{'bondsman-search-results-row-'+ i + 'bondsman-license-number'}}"
          width="25%"
          title="Click for Bondsman View" >
         <span title="{{bondsman.getLicenseNumber()}}">{{bondsman.getLicenseNumber()}}</span>
      </td>
      <td id="{{'bondsman-search-results-row-'+ i + '-bondsman-license-type'}}"  
          width="30%"
          title="Click for Bondsman View" >
         <div>
           <li *ngFor="let licenseType of bondsman.getLicenseTypeList()" title="{{licenseType.licenseType}}"><span>{{licenseType.licenseType}}</span></li>
         </div>
      </td>  
      <td id="{{'bondsman-search-results-row-'+ i + '-bondsman-action'}}" 
          width="15%"
          (click)="$event.stopPropagation()">
        <a id="{{'bondsman-search-results-row-'+ i + '-bondsman-action-view-bondsman-lnk'}}" 
            tabindex="{{1000 + i*5 + 3}}"
            title="Click for Case View" (click)="onViewBondsmanSelected(bondsman.getBondsmanIdentifier())">
            <span class="glyphicon glyphicon-folder-open"></span><span> View Detail</span>
        </a>
      </td>
    </tr>
   </ng-container>
   </tbody>
</table>

</div>
<ng-template #popTemplateForAction>
    <div class='popover-section'>Click &lt;View Detail&gt; to see the details on the bondsman.</div>
</ng-template>



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/bondsman/bondsman-search-results-table/bondsman-search-results-table.component.html